import { createAction } from 'redux-actions';

export const isExistingSiteUpdateAction = createAction(
  'FORM_IS_EXISTING_SITE_UPDATE'
);

export const updateIsExistingSite = value => (dispatch, getState) =>
  dispatch(isExistingSiteUpdateAction(value));



// WEBPACK FOOTER //
// ./src/modules/saas/aast/common/modals/case-transfer/actions/form.js